export const SET_ERROR = '@error/SET_ERROR';
export const CLEAR_ERROR = '@error/CLEAR_ERROR';
